import {observer} from 'mobx-react';
import FilterComponent from 'main/components/tables/interactive/components/fancy_filter/filter_selector/FilterComponent';
import {visibleEventTypes} from 'main/stores/calendar_events';
import {t} from 'shared/core';

const eventTypeOptions = () => visibleEventTypes().map(({value, labelKey}) => ({
  value,
  label: t(`components.tables.fancy_filters.selectors.${labelKey}`)
}));

const EventType = observer(({filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  return <FilterComponent filter={filter} filterKey={filterKey} options={eventTypeOptions()} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
});

export default EventType;
